<template>
  <el-dialog title="微课预览" :visible.sync="dialogVisible" width="75%" top="10px" @close="closedlg">
      <!-- <el-carousel trigger="click" height="400px">
      <el-carousel-item v-for="item in pages" :key="item.id"> -->
        <!-- <h3 class="small"></h3> -->
        <!-- <img class="page-img" :src="imgs" alt=""> -->
        <iframe class="page-img" :src="imgs" frameborder="0" allow="autoplay" allowfullscreen="true"></iframe>
        <!-- <h3>{{item.page}}</h3> -->
      <!-- </el-carousel-item>
    </el-carousel> -->
  </el-dialog>
</template>

<script>
export default {
    props:['boardId'],
  data() {
    return {
      dialogVisible: false,
      pages:[],
      imgs:'',
    };
  },
   mounted(){
  },
  methods: {
    closedlg(){
      this.imgs = null
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    async writingDetail(){
        console.log('haha',this.boardId)
        const res = await this.$axios.post("/base/board/detail",{
            board_id:this.boardId,
        });
      if (res.status == 200 && res.data.errCode == 0) {
          console.log(res.data.data)
          console.log(res.data.data.pages)
          console.log(res.data.data.pages[0].page)
          this.pages = res.data.data.pages
      } else {
        this.$message.error(res.data.message);
      }
    },
  },
  watch: {
    boardId (newName, oldName) {
        console.log(newName)
        this.boardId = newName
    }
}
};
</script>

<style lang="scss" scoped>
.page-img{
    width: 100%;
    // height: 100%;
    height: 770px;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/weike/detail.vue